import { inject } from 'vue';

/**
 * Composable for accessing booking actions from any child component
 * Uses Vue's inject to get the actions provided by BookingActionsProvider
 */
export function useBookingActions() {
	const bookingActions = inject('bookingActions');
	
	if (!bookingActions) {
		console.warn(
			'useBookingActions() could not find BookingActionsProvider. ' +
			'Some booking functionality may not be available. ' +
			'Make sure to wrap your component with <BookingActionsProvider>.'
		);
		// Return empty object with safe defaults to prevent errors
		return {
			createBooking: () => console.warn('BookingActionsProvider not found'),
			editBooking: () => console.warn('BookingActionsProvider not found'),
			viewBooking: () => console.warn('BookingActionsProvider not found'),
			deleteBooking: () => console.warn('BookingActionsProvider not found'),
			registerCalendarRefresh: () => {},
			unregisterCalendarRefresh: () => {},
		};
	}
	
	return bookingActions;
}